import { REQUEST_FLC_LIST, RECEIVE_FLC_LIST, ERROR_FLC_LIST } from "typeConstants";
import { fieldLevelCoordinators as initialState } from "reducers/initialState.tsx";

const fieldLevelCoordinators = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_FLC_LIST:
      return {
        ...state,
        isFetchingFieldLevelCoordinators: true
      };
    case RECEIVE_FLC_LIST:
      return {
        ...state,
        isFetchingFieldLevelCoordinators: false,
        list: action.payload
      };
    case ERROR_FLC_LIST:
      return {
        ...state,
        isFetchingFieldLevelCoordinators: false
      };
    default:
      return state;
  }
};

export default fieldLevelCoordinators;